<template>
  <div data-active-conversation-header-container class="ac-header" v-on="$listeners">
    <div data-ac-header-messages-logo class="ac-header-icon">
      <img width="25px" class="logo" :src="require('@/assets/img/shared/default/logo.png')" />
    </div>
    <div data-ac-header-title-and-subtitle class="ac-header-content">
      <span class="ac-header-content-title">
        {{ $t('page.active_conversation.my_conversations') }}
      </span>
    </div>
    <div v-if="activeConversations" class="ac-header-badge">
      <BasicBadge :value="activeConversations" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import BasicBadge from '@/components/BasicBadge.vue';

@Component({ components: { BasicBadge } })
export default class ConversationHeader extends Vue {
  @Prop() readonly activeConversations!: number | string;
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';

.ac-header {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: $ac-sticky-header-background;

  gap: $size-xs;

  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
  z-index: 10;

  .ac-header-icon {
    flex: 0 0 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ac-header-content {
    flex: 1;
    span {
      display: block;
    }

    .ac-header-content-title {
      font-weight: 600;
      font-size: $size-m;
      line-height: 1;
      color: $ac-sticky-header-title-color;
    }

    .ac-header-content-subtitle {
      color: $ac-sticky-header-subtitle-color;
      font-size: $size-m2;
    }
  }

  .ac-header-badge {
    display: flex;
    align-items: center;
  }
}
</style>
